// Replacing these constants with DB table
// would require us to inform frontend of total list of emojis
export const JOY = 'joy';
export const LOVE = 'love';
export const WOW = 'wow';
export const NERVOUS = 'nervous';
export const UP = 'up';
export const DOWN = 'down';
export const YAY = 'yay';

export const EMOJIS = {
  [JOY]: '😂',
  [LOVE]: '😍',
  [WOW]: '😮',
  [NERVOUS]: '😕',
  [UP]: '👍',
  [DOWN]: '👎',
  [YAY]: '🙌',
};

export const EMOJI_SIZES = ['', '@2x', '@3x'];

// All emojis in an ID => name mapping
export default {
  1: JOY,
  2: LOVE,
  3: WOW,
  4: NERVOUS,
  5: YAY,
  6: UP,
  7: DOWN,
};

export const MAX_FETCH_REACTIONS = 50;
